import React from 'react';
import { ToastContainer as ReactToastifyToastContainer } from 'react-toastify';

export default function ToastContainer() {
  return <ReactToastifyToastContainer />;
}
